import * as config from "config-api";
export const GRAPHQL_URL = config.getString("Client.contentApi.baseGraphqlURL");
